// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yqu_","label":"styles_label__22QTx"};